import React from 'react';
import { ArrowForwardRounded } from '@mui/icons-material';
import { Box, Typography, Skeleton } from '@mui/material';

interface StatisticsTabProps {
    icon: React.ReactNode;
    label: string;
    value?: number | null;
    loading?: boolean;
    onClick?: () => void;
}

export const StatisticsTab: React.FC<StatisticsTabProps> = ({ icon, label, value, loading, onClick }) => {

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <Box
            onClick={handleClick}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                p: 2,
                minHeight: 112,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                cursor: onClick ? 'pointer' : 'default',
                backgroundColor: 'background.paper',
                boxShadow: '0 8px 24px rgba(35, 35, 45, 0.04)',
                transition: 'border-color 180ms ease, box-shadow 180ms ease, background-color 180ms ease',
                '&:hover': onClick ? {
                    borderColor: 'primary.main',
                    boxShadow: '0 12px 28px rgba(87, 74, 170, 0.12)',
                    backgroundColor: 'primary.light',
                } : {},
            }}
        >
            <Box className="tab-icon" sx={{ color: 'primary.main', display: 'grid', placeItems: 'center', bgcolor: 'primary.light', width: 44, height: 44, borderRadius: 1.5, flexShrink: 0 }}>
                {icon}
            </Box>
            <Box sx={{ flex: 1 }}>
                <Typography className="tab-text" variant="body2" sx={{ color: 'text.secondary', mb: 0.5, fontWeight: 600 }}>
                    {label}
                </Typography>
                {loading ? (
                    <Skeleton variant="text" width={60} height={32} />
                ) : (
                    value === undefined ? (
                        <Typography className="tab-value" variant="body2" sx={{ color: 'primary.dark', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            Открыть <ArrowForwardRounded fontSize="small" />
                        </Typography>
                    ) : (
                        <Typography className="tab-value" variant="h4" sx={{ color: 'text.primary', fontWeight: 800 }}>
                            {value ?? 0}
                        </Typography>
                    )
                )}
            </Box>
        </Box>
    );
};
